'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var InputAdornment = require('@material-ui/core/InputAdornment');
var Typography = require('@material-ui/core/Typography');
var FormControl = require('@material-ui/core/FormControl');
var FormHelperText = require('@material-ui/core/FormHelperText');
var InputLabel = require('@material-ui/core/InputLabel');
var Grid = require('@material-ui/core/Grid');
var luxon = require('luxon');
var DateField = require('../DateField/DateField.js');
var TimeField = require('../TimeField/TimeField.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var InputAdornment__default = /*#__PURE__*/_interopDefaultLegacy(InputAdornment);
var Typography__default = /*#__PURE__*/_interopDefaultLegacy(Typography);
var FormControl__default = /*#__PURE__*/_interopDefaultLegacy(FormControl);
var FormHelperText__default = /*#__PURE__*/_interopDefaultLegacy(FormHelperText);
var InputLabel__default = /*#__PURE__*/_interopDefaultLegacy(InputLabel);
var Grid__default = /*#__PURE__*/_interopDefaultLegacy(Grid);

var _excluded = ["start", "end", "onChange", "isStacked", "label", "error", "helperText"];
var DateTimeRangeField = _ref => {
  var {
    start: startFromProps,
    end: endFromProps,
    onChange,
    isStacked,
    label = '',
    error = false,
    helperText = ''
  } = _ref,
      textFieldProps = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  var start = startFromProps && !startFromProps.invalid ? startFromProps : luxon.DateTime.local().startOf('hour');
  var end = endFromProps && !endFromProps.invalid ? endFromProps : start.plus({
    hours: 1
  });
  var duration = end.diff(start);
  var hasNegativeDuration = duration < 0;
  var durationToAdd = hasNegativeDuration ? luxon.Duration.fromObject({
    hours: 1
  }) : duration; // If the duration is less than an hour, display the time in minutes
  // If the duraction is less than a day, display the time in hours
  // Otherwise display in days.

  var durationString = hasNegativeDuration ? '' : duration.as('hours') < 1 ? "".concat(Math.floor(duration.as('minutes')), " m") : duration.as('days') < 1 ? "".concat(Math.floor(duration.as('hours')), " h") : "".concat(Math.floor(duration.as('days')), " d");
  /**
   * Callback to handle a change to the start date.
   * The hour and minutes values will stay the same as the original start
   * value. The end will shift based on the original duration.
   * @param {object} newStartDate
   */

  var handleStartDateChange = newStartDate => {
    var _newStartDate$set, _newStart$plus;

    var newStart = (_newStartDate$set = newStartDate === null || newStartDate === void 0 ? void 0 : newStartDate.set({
      hour: start.hour,
      minute: start.minute
    })) !== null && _newStartDate$set !== void 0 ? _newStartDate$set : null;
    var newEnd = (_newStart$plus = newStart === null || newStart === void 0 ? void 0 : newStart.plus(durationToAdd)) !== null && _newStart$plus !== void 0 ? _newStart$plus : null;
    onChange(newStart, newEnd);
  };
  /**
   * Callback to handle a change to the start time.
   * The date values will stay the same as the original start value. The end
   * will shift based on the original duration.
   * @param {object} newStartTime
   */


  var handleStartTimeChange = newStartTime => {
    var _newStartTime$set, _start$plus;

    var newStart = (_newStartTime$set = newStartTime === null || newStartTime === void 0 ? void 0 : newStartTime.set({
      day: start.day,
      month: start.month,
      year: start.year
    })) !== null && _newStartTime$set !== void 0 ? _newStartTime$set : null;
    var newEnd = (_start$plus = start === null || start === void 0 ? void 0 : start.plus(durationToAdd)) !== null && _start$plus !== void 0 ? _start$plus : null;
    onChange(newStart, newEnd);
  };
  /**
   * Callback to handle a change to the end time.
   * The date values will start the same as the original end value. The start
   * will not be affecting (thus changing the duration).
   * @param {object} newEndTime
   */


  var handleEndTimeChange = newEndTime => {
    var _newEndTime$set;

    var newEnd = (_newEndTime$set = newEndTime === null || newEndTime === void 0 ? void 0 : newEndTime.set({
      day: end.day,
      month: end.month,
      year: end.year
    })) !== null && _newEndTime$set !== void 0 ? _newEndTime$set : null;
    onChange(start, newEnd);
  };
  /**
   * Callback to handle a change to the end date.
   * The hour and minutes values will stay the same as the original end
   * value. The start will not be affected (thus changing the duration).
   * @param {object} newEndDate
   */


  var handleEndDateChange = newEndDate => {
    var newEnd = newEndDate === null || newEndDate === void 0 ? void 0 : newEndDate.set({
      hour: end.hour,
      minute: end.minute
    });
    onChange(start, newEnd);
  };

  var startDate = /*#__PURE__*/React__default['default'].createElement(DateField.DateField, _rollupPluginBabelHelpers['extends']({
    error: error,
    label: isStacked ? 'From' : null,
    value: startFromProps ? start : null,
    onChange: handleStartDateChange
  }, textFieldProps));
  var startTime = /*#__PURE__*/React__default['default'].createElement(TimeField.TimeField, _rollupPluginBabelHelpers['extends']({
    error: error,
    value: startFromProps ? start : null,
    onChange: handleStartTimeChange
  }, textFieldProps));
  var endTime = /*#__PURE__*/React__default['default'].createElement(TimeField.TimeField, _rollupPluginBabelHelpers['extends']({
    error: error,
    value: endFromProps ? end : null,
    onChange: handleEndTimeChange,
    InputProps: {
      endAdornment: /*#__PURE__*/React__default['default'].createElement(InputAdornment__default['default'], {
        position: "end"
      }, /*#__PURE__*/React__default['default'].createElement(Typography__default['default'], {
        variant: "caption",
        color: "textSecondary"
      }, durationString))
    }
  }, textFieldProps));
  var endDate = /*#__PURE__*/React__default['default'].createElement(DateField.DateField, _rollupPluginBabelHelpers['extends']({
    error: error,
    label: isStacked ? 'To' : null,
    value: endFromProps ? end : null,
    onChange: handleEndDateChange
  }, textFieldProps));
  return /*#__PURE__*/React__default['default'].createElement(FormControl__default['default'], {
    error: error
  }, Boolean(label) && /*#__PURE__*/React__default['default'].createElement(InputLabel__default['default'], null, label), isStacked ? /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
    item: true,
    xs: 6
  }, startDate), /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
    item: true,
    xs: 6
  }, startTime), /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
    item: true,
    xs: 6
  }, endDate), /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
    item: true,
    xs: 6
  }, endTime)) : /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
    container: true,
    spacing: 1,
    alignItems: "center"
  }, /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
    item: true,
    style: {
      flex: 1
    }
  }, startDate), /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
    item: true,
    style: {
      flex: 1
    }
  }, startTime), /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
    item: true,
    style: {
      flex: 0
    }
  }, /*#__PURE__*/React__default['default'].createElement(Typography__default['default'], {
    variant: "body2"
  }, "to")), /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
    item: true,
    style: {
      flex: 1
    }
  }, endTime), /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
    item: true,
    style: {
      flex: 1
    }
  }, endDate)), Boolean(helperText) && /*#__PURE__*/React__default['default'].createElement(FormHelperText__default['default'], null, helperText));
};
DateTimeRangeField.propTypes = {
  start: index.object,
  end: index.object,
  onChange: index.func,
  isStacked: index.bool,
  label: index.string,
  variant: index.oneOf(['filled', 'outlined', 'standard']),
  helperText: index.string,
  error: index.bool
};

exports.DateTimeRangeField = DateTimeRangeField;
